export default __webpack_public_path__ + "static/media/enclavesnew.c21b9b61.webp";